require('./RAPatrimonyDetails.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @components
const RAOneLineSymbolAmount = require('../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('components/commons/OKModal/OKModal');

// @constants
const { PERCENTAGE_SYMBOL, EURO_TEXT } = require('constants/index');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;
const { recordLinkV2 } = require('utilities/tagging');

class RAPatrimonyDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
        this.handleAmountInfoModalToggle = this.handleAmountInfoModalToggle.bind(
            this,
        );
    }

    handleAmountInfoModalToggle() {
        const customData = {
            categoriaEvento: 'myPortfolioHomeInteraction',
            accionEvento: 'aboutAmount',
            etiquetaEvento: '',
        };
        recordLinkV2(customData);

        const { onClickHandler } = this.props;
        onClickHandler();
        this.setState({
            isModalOpen: !this.state.isModalOpen,
        });
    }

    buildDetailPatrimonyContent() {
        const {
            ownAccountAmount,
            discretionaryAccountAmount,
            ownAccountPercent,
            discretionaryAccountPercent,
        } = this.props;
        const amountContent = this.buildAmountContent();
        const ownAccountPercentValidated =
            ownAccountPercent > 0 ? Math.round(ownAccountPercent * 100) : 0;
        const discretionaryAccountPercentValidated =
            discretionaryAccountPercent > 0
                ? Math.round(discretionaryAccountPercent * 100)
                : 0;
        const lineActive = { width: `${ownAccountPercentValidated}%` };
        const ownPercentClass = classnames(
            'ra-patrimony-details__container-left-percents-text',
            {
                'ra-patrimony-details__container-left-percents-text--active':
                    ownAccountPercent > 0,
            },
        );
        const discretionaryPercentClass = classnames(
            'ra-patrimony-details__container-left-percents-text',
            {
                'ra-patrimony-details__container-left-percents-text--active':
                    discretionaryAccountPercent > 0,
            },
        );
        const ownAmountClass = classnames(
            'ra-patrimony-details__container-left-labels-text',
            {
                'ra-patrimony-details__container-left-labels-text--active':
                    ownAccountAmount.amount > 0,
            },
        );
        const discretionaryAmountClass = classnames(
            'ra-patrimony-details__container-left-labels-text',
            {
                'ra-patrimony-details__container-left-labels-text--active':
                    discretionaryAccountAmount.amount > 0,
            },
        );
        return (
            <div className="ra-patrimony-details">
                <div className="ra-patrimony-details__container-left">
                    <div className="ra-patrimony-details__container-left-percents">
                        <div className={ownPercentClass}>
                            {ownAccountPercentValidated}
                            &nbsp;
                            <span className="ra-patrimony-details__container-left-percent-symbol">
                                {PERCENTAGE_SYMBOL}
                            </span>
                        </div>
                        <div className={discretionaryPercentClass}>
                            {discretionaryAccountPercentValidated}
                            &nbsp;
                            <span className="ra-patrimony-details__container-left-percent-symbol">
                                {PERCENTAGE_SYMBOL}
                            </span>
                        </div>
                    </div>
                    <div className="ra-patrimony-details__container-left-line">
                        <div
                            className="ra-patrimony-details__container-left-line-active"
                            style={lineActive}
                        />
                    </div>
                    <div className="ra-patrimony-details__container-left-labels">
                        <div className={ownAmountClass}>
                            <RAOneLineSymbolAmount
                                amountObject={ownAccountAmount}
                            />
                        </div>
                        <div className={discretionaryAmountClass}>
                            <RAOneLineSymbolAmount
                                amountObject={discretionaryAccountAmount}
                            />
                        </div>
                    </div>
                    <div className="ra-patrimony-details__container-left-descriptions">
                        <div className="ra-patrimony-details__container-left-descriptions-left">
                            <FormattedText value="raPatrimonyDetails-newOwnAccountLabel" />
                        </div>
                        <div className="ra-patrimony-details__container-left-descriptions-right">
                            <FormattedText value="raPatrimonyDetails-newDiscretionaryAccountLabel" />
                        </div>
                    </div>
                </div>
                <div className="ra-patrimony-details__container-amountsection">
                    {amountContent}
                </div>
            </div>
        );
    }

    buildAmountContent() {
        const { ownAccountAmount, discretionaryAccountAmount } = this.props;
        const totalAmount =
            ownAccountAmount.amount + discretionaryAccountAmount.amount;
        const totalAmountFormatted = {
            amount: totalAmount,
            currency: EURO_TEXT,
        };
        const totalLabelText =
            ownAccountAmount.amount > 0 && discretionaryAccountAmount.amount > 0
                ? formatText('raPatrimonyDetails-totalCarteraDeInversiones')
                : formatText('raPatrimonyDetails-totalLabel');
        const amountClassName = classnames(
            'ra-patrimony-details__container-amountsection-right',
            {
                'ra-patrimony-details__container-amountsection-right--amountbox': !(
                    ownAccountAmount.amount > 0 &&
                    discretionaryAccountAmount.amount > 0
                ),
            },
        );
        return (
            <div className={amountClassName}>
                <div className="ra-patrimony-details__container-amountsection-right-label">
                    <div className="ra-patrimony-details__container-amountsection-right-label-text">
                        {totalLabelText}
                    </div>
                </div>
                <div className="ra-patrimony-details__container-amountsection-right-amount">
                    <RAOneLineSymbolAmount
                        amountObject={totalAmountFormatted}
                    />
                </div>
                <OKLink
                    onClick={this.handleAmountInfoModalToggle}
                    modifier="emphasize"
                >
                    {formatText(
                        'raPatrimonyDetails-raPatrimonyDetails_amountInfo',
                    )}
                </OKLink>
            </div>
        );
    }

    buildAmountInfoModal() {
        return (
            <OKModal
                description="raPatrimonyDetails-raPatrimonyDetails_modalDescription"
                descriptionAlignment="center"
                footerType="action"
                isOpen={this.state.isModalOpen}
                onCloseCallback={this.handleAmountInfoModalToggle}
                onPrimaryButtonClick={this.handleAmountInfoModalToggle}
                primaryButtonText="raPatrimonyDetails-raPatrimonyDetails_modalUnderstandButton"
                shouldCloseOnOverlayClick={true}
                title="raPatrimonyDetails-raPatrimonyDetails_amountInfo"
                titleAlignment="center"
            />
        );
    }

    render() {
        const { ownAccountAmount, discretionaryAccountAmount } = this.props;
        const patrimonyContent =
            ownAccountAmount.amount > 0 && discretionaryAccountAmount.amount > 0
                ? this.buildDetailPatrimonyContent()
                : this.buildAmountContent();
        const amountInfoModal = this.buildAmountInfoModal();

        return (
            <div>
                {patrimonyContent}
                {amountInfoModal}
            </div>
        );
    }
}

RAPatrimonyDetails.propTypes = {
    discretionaryAccountAmount: PropTypes.object.isRequired,
    discretionaryAccountPercent: PropTypes.number,
    onClickHandler: PropTypes.func,
    ownAccountAmount: PropTypes.object.isRequired,
    ownAccountPercent: PropTypes.number,
};

module.exports = RAPatrimonyDetails;
